// removed by extract-text-webpack-plugin
module.exports = {"columns-zone-header":"index__columns-zone-header___9qSS9","columnsDz":"index__columnsDz___27J24","iconWrapper":"index__iconWrapper___2XLdF","icon":"index__icon___2vdps","filled":"index__filled___1-Rb8","hover":"index__hover___KaeSk","dropzone":"index__dropzone___3me05"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/Dropzones/index.less
// module id = 440
// module chunks = 3